import { OverlaySpinner } from '@ankr.com/ui';
import loadable from '@loadable/component';

import { NonEnterpriseGuard } from 'modules/accountStatus/components/EnterpriseGuard';
import { PageWithBillingTabs } from 'modules/common/components/PageWithBillingTabs';
import { homeRoutesConfig } from 'domains/home/routes';
import { useAuth } from 'modules/auth/hooks/useAuth';

const PricingPage = loadable(
  async () => {
    const module = await import('./PricingPage');

    return module.PricingPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

const homePath = homeRoutesConfig.home.generatePath();

export const PricingPageContainer = () => {
  const { isLoggedIn } = useAuth();

  return (
    <PageWithBillingTabs hasTabs={isLoggedIn}>
      <NonEnterpriseGuard fallback={homePath}>
        <PricingPage />
      </NonEnterpriseGuard>
    </PageWithBillingTabs>
  );
};
